import { ImmutableLedgerDemo } from '#app/features/portfolio/demos/immutable-ledger/immutable-ledger-demo.tsx'
import { type Route } from './+types/writing.immutable-ledger.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Why editing the books destroys history · slvr.mn' },
	{
		name: 'description',
		content:
			'An interactive demo: make the same edits to an append-only journal and a mutable one, then ask each what it said on a past date. Only one can answer.',
	},
]

export default function ImmutableLedger() {
	return <ImmutableLedgerDemo />
}
